var _excluded = ["onChange", "triggerOnce", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React from "react";
import { handleMultipleRefs } from "../../utils/helpers";
import useInView from "../../hooks/useInView/useInView";

/**
 * Keeps track of a child component's visibility
 * in the screen. The child component _must_ accept
 * a forward ref.
 */
var AInView = function AInView(props) {
  var onChange = props.onChange,
    triggerOnce = props.triggerOnce,
    children = props.children,
    observerConfig = _objectWithoutProperties(props, _excluded);
  var ref = useInView(onChange, _objectSpread({
    triggerOnce: triggerOnce
  }, observerConfig));
  return /*#__PURE__*/React.cloneElement(children, {
    ref: handleMultipleRefs(ref, children.ref)
  });
};
function withinValidThreshold(props, propName) {
  var propValue = props[propName];
  if (propValue < 0 || propValue > 1) {
    throw new Error("Invalid prop threshold.");
  }
}
AInView.defaultProps = {
  onChange: null,
  triggerOnce: false,
  children: /*#__PURE__*/React.createElement(React.Fragment, null)
};
AInView.propTypes = {
  /**
   * The function to be called when the component
   * toggles entering and exiting the view. An object
   * with an `inView` property is passed.
   */
  onChange: PropTypes.func,
  /**
   * Determines if the `onChange` handler should
   * only be called on the first initial instance
   * of the component being in the view
   */
  triggerOnce: PropTypes.bool,
  /**
   * The container of the child component rendered
   * inside of `AInView`. If not passed, it defaults
   * to the browser viewport (specified as `null`).
   * The root should almost always be a scrollable
   * container.
   */
  root: PropTypes.object,
  /**
   * A bound you can set on the child component passed
   * to `AInView` as to how many margin pixels the
   * trigger should be induced.
   */
  rootMargin: PropTypes.string,
  /**
   * A value between 0 and 1 which indicates what percentage
   * of the child component should be in the view before
   * the trigger is induced. A value of `0` will trigger
   * when the first pixel enters the view, whereas a value
   * of `1` requires the entire component to be in the view
   * (assuming no `rootMargin` props are passed as well)
   */
  threshold: withinValidThreshold
};
export default AInView;